export default "__VITE_ASSET__BV46LBkH__"